import Quote from "../quote/Quote"
import { Row } from "./Row"
import { isBundleItem } from "../../utils"

class RowQuantityService {
    getItemListOrderedFromQuote(quote: Quote) {
        let itemsListToOrder = quote.getAttributes().items.map(item => {
            return this.processRow(item)
        })

        let createOrderDisabled = true
        for (const item of itemsListToOrder) {
            if (parseFloat(item.attributes.orderedMeasure as string) < parseFloat(item.attributes.measure)) {
                createOrderDisabled = false
                break
            }
        }

        itemsListToOrder = itemsListToOrder.filter(item => !isBundleItem(item))
        return { itemsListToOrder, createOrderDisabled }
    }

    processRow(item: Row) {
        const measureToApply = "measureToOrder"
        const measureApplied = "orderedMeasure"
        const maxMeasureApplied = "maxMeasureOrdered"
        const itemType = "type"
        const itemTypeOptionForCustomer = "option-for-customer"
        const itemTypeMultipleChoice = "multiple-choice"

        item.checked = true
        item.attributes[measureToApply] = parseFloat(
            item.attributes.totalMeasure) - parseFloat(
                item.attributes[measureApplied] as string)
        if ((parseFloat(item.attributes[measureApplied] as string) >= parseFloat(item.attributes.totalMeasure))) {
            item.disabled = true
            item.checked = false
        }
        if (item.attributes[measureApplied] < 0)
            item.attributes[measureApplied] = 0
        if (parseFloat(item.attributes.totalMeasure) <= 0) {
            item.disabled = true
            item.checked = false
        }
        if (item.attributes[itemType] == itemTypeOptionForCustomer || item.attributes[itemType] == itemTypeMultipleChoice) {
            item.checked = false
        }
        item.attributes[maxMeasureApplied] = item.attributes[measureToApply]
        return item
    }
}

const instance = new RowQuantityService()
export default instance


// WEBPACK FOOTER //
// ./src/state/rows/RowQuantityService.ts